import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type ParcelState = {
  parcel: string;
  roomData: Record<string, string> | null;
  setParcelState: (state: string) => void;
  setRoomData: (data: Record<string, string> | null) => void;
};

export const useParcelStore = create<ParcelState>()(persist((set) => ({
  parcel: '',
  roomData: null,
  setParcelState: (parcel) => set(() => ({ parcel })),
  setRoomData: (roomData) => set(() => ({ roomData })),
}), {
  name: 'parcel', 
}));